import type {
  CompanyProfileFormData,
  CompanySettingsCompany,
  CompanySettingsResponse,
  SystemSettingsFormData,
} from '../types/companySettings';

export type {
  CompanyCurrency,
  CompanyProfileFormData,
  CompanySettingsCompany,
  CompanySettingsResponse,
  SystemSettingsFormData,
} from '../types/companySettings';

export const emptyCompanyProfileFormData: CompanyProfileFormData = {
  companyName: '',
  currency: 'EUR',
  taxId: '',
  email: '',
  phoneNumber: '',
  website: '',
  streetAddress: '',
  city: '',
  state: '',
  postalCode: '',
  country: '',
  operatingHoursStart: '08:00',
  operatingHoursEnd: '18:00',
  operatingDays: 'Monday-Sunday',
  contactPersonName: '',
  contactPersonTitle: '',
  emergencyContact: '',
  description: '',
  heroTagline: '',
  instagramUrl: '',
  facebookUrl: '',
  whatsappNumber: '',
  bankName: '',
  bankAccountNumber: '',
  bankRoutingNumber: '',
};

export const defaultSystemSettingsFormData: SystemSettingsFormData = {
  reservationNumber: 1,
  invoiceNumber: 1,
};

export const settingsCardSx = {
  p: 3,
  borderRadius: 3,
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: 'none',
};

export const mapCompanyToCompanyProfileFormData = (
  company?: CompanySettingsCompany
): CompanyProfileFormData => ({
  companyName: company?.companyName || '',
  currency: company?.currency || 'EUR',
  taxId: company?.taxId || '',
  email: company?.email || '',
  phoneNumber: company?.phoneNumber || '',
  website: company?.website || '',
  streetAddress: company?.streetAddress || '',
  city: company?.city || '',
  state: company?.state || '',
  postalCode: company?.postalCode || '',
  country: company?.country || '',
  operatingHoursStart: company?.operatingHoursStart || '08:00',
  operatingHoursEnd: company?.operatingHoursEnd || '18:00',
  operatingDays: company?.operatingDays || 'Monday-Sunday',
  contactPersonName: company?.contactPersonName || '',
  contactPersonTitle: company?.contactPersonTitle || '',
  emergencyContact: company?.emergencyContact || '',
  description: company?.description || '',
  heroTagline: company?.heroTagline || '',
  instagramUrl: company?.instagramUrl || '',
  facebookUrl: company?.facebookUrl || '',
  whatsappNumber: company?.whatsappNumber || '',
  bankName: company?.bankName || '',
  bankAccountNumber: company?.bankAccountNumber || '',
  bankRoutingNumber: company?.bankRoutingNumber || '',
});

const parseSequenceNumber = (nextNumber?: string) => {
  if (!nextNumber) {
    return 1;
  }

  const numericPart = parseInt(nextNumber.substring(2), 10);
  return Number.isFinite(numericPart) ? numericPart : 1;
};

export const mapSettingsToSystemSettingsFormData = (
  settings?: CompanySettingsResponse
): SystemSettingsFormData => ({
  reservationNumber: parseSequenceNumber(settings?.reservationSequence?.nextNumber),
  invoiceNumber: parseSequenceNumber(settings?.invoiceSequence?.nextNumber),
});

export const buildSequencePreview = (sequenceNumber: number, year = new Date().getFullYear()) =>
  `${String(year).slice(-2)}${String(sequenceNumber).padStart(5, '0')}`;
